import React from 'react';
import Button from 'components/button';
import { LocalForm, Control } from 'react-redux-form';
import enhance from './enhance';

const LoginItem = ({ label, type, model }) => (
  <div className="login-item">
    <label className="login-label">{label}</label>
    <Control.input
      autoComplete="off"
      className="login-input"
      model={model}
      type={type}
      updateOn={['change', 'blur']}
    />
  </div>
);

const signInButtonText = ({ isLoggingIn, isLoggedIn }) => {
  if (isLoggedIn) return 'Signed in';
  if (isLoggingIn) return 'Signing in...';
  return 'Sign in';
};

const LoginForm = ({ onSubmit, isLoggingIn, isLoggedIn, invalidLogin }) => (
  <main className="">
    <LocalForm className="" onSubmit={onSubmit}>
      <fieldset className="login-items">
        <legend className="login-header"><h3>Wilshire Grand</h3></legend>
        <LoginItem label="Email" type="email" model=".email" />
        <LoginItem label="Password" type="password" model=".password" />
      </fieldset>
      {invalidLogin &&
        <div className="invalid-login">
          <i className="ui icon warning sign" /> Invalid Credentials
        </div>}
      <Button disabled={isLoggingIn || isLoggedIn}>
        {signInButtonText({ isLoggingIn, isLoggedIn })}
        <input className="hidden-input" type="submit" value="Sign in" />
      </Button>
    </LocalForm>
  </main>
);

export default enhance(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login/login-form/index.js